import { useEffect, useRef } from 'react'

export function useScrollAnimation() {
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate-in')

                        // Also animate child cards if they exist
                        const cards = entry.target.querySelectorAll('.card-slide-left')
                        cards.forEach((card) => {
                            card.classList.add('animate-in')
                        })

                        // Animate directional elements
                        const slideTop = entry.target.querySelectorAll('.slide-top')
                        const slideLeft = entry.target.querySelectorAll('.slide-left-in')
                        const slideRight = entry.target.querySelectorAll('.slide-right-in')

                        slideTop.forEach((el) => el.classList.add('animate-in'))
                        slideLeft.forEach((el) => el.classList.add('animate-in'))
                        slideRight.forEach((el) => el.classList.add('animate-in'))
                    }
                })
            },
            {
                threshold: 0.1,
                rootMargin: '0px'
            }
        )

        const currentRef = ref.current
        if (currentRef) {
            observer.observe(currentRef)
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef)
            }
        }
    }, [])

    return ref
}
